<template>
    <b-modal
        ref="modal"
        title="Criar limite"
        header-bg-variant="secondary"
        header-text-variant="light"
        footer-bg-variant="light"
        cancel-variant="danger"
        cancel-title="Cancelar"
        ok-variant="secondary"
        :busy="saving"
        scrollable
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        no-fade
        @ok.prevent="confirm"
    >
        <b-form @submit.prevent="">
            <b-form-group label="Sensor" label-for="sensor-limit-create-sensor">
                <b-form-select
                    id="sensor-limit-create-sensor"
                    :value="limit.sensor.id"
                    :options="optionsSensors"
                    required
                    :disabled="saving"
                    @input="setSensor"
                />
            </b-form-group>
            <b-form-group
                label="Condição"
                label-for="sensor-limit-create-condition"
            >
                <b-form-select
                    id="sensor-limit-create-condition"
                    :value="limit.condition"
                    :options="optionsConditions"
                    required
                    :disabled="saving"
                    @input="setProp('condition', $event)"
                />
            </b-form-group>
            <b-form-group label="Valor" label-for="sensor-limit-create-value">
                <swx-number-input
                    id="sensor-limit-create-value"
                    name="sensor-limit-create-value"
                    :value="limit.value"
                    required
                    :disabled="saving"
                    @update="setProp('value', $event)"
                />
            </b-form-group>
            <b-form-group
                label="Tipo (unidade)"
                label-for="sensor-limit-create-kind"
            >
                <b-form-select
                    id="sensor-limit-create-kind"
                    :value="limit.kind"
                    :options="optionsKinds"
                    required
                    :disabled="saving"
                    @input="setProp('kind', $event)"
                />
            </b-form-group>
            <b-form-group
                label="Nível de alerta"
                label-for="sensor-limit-create-alert_level"
            >
                <b-form-select
                    id="sensor-limit-create-alert_level"
                    :value="limit.alert_level"
                    :options="optionsAlerts"
                    :disabled="saving"
                    required
                    @input="setProp('alert_level', $event)"
                />
            </b-form-group>
        </b-form>
        <template #modal-ok>
            <template v-if="saving"> <b-spinner small /> Criando... </template>
            <template v-else>Criar</template>
        </template>
    </b-modal>
</template>

<script>
import { ESensor } from "@/modules/common/store/sensors";
import SwxNumberInput from "@/components/SwxNumberInput";
import hasProperty from "@/utils/hasProperty";
import settingsApi from "@/modules/settings/api";
import sleep from "@/utils/sleep";

export default {
    name: "SensorLimitCreateModal",
    components: { SwxNumberInput },
    inject: [
        "LimitConditions",
        "AlertLevels",
        "getOptionsSensors",
        "optionsConditions",
        "getOptionsKinds",
        "optionsAlerts"
    ],
    props: {
        source: {
            type: Number,
            required: true
        },
        sensors: {
            type: Array,
            required: true
        },
        readingKinds: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            saving: false,
            limit: this.getNewLimit()
        };
    },
    computed: {
        optionsSensors() {
            return this.getOptionsSensors();
        },
        optionsKinds() {
            return this.getOptionsKinds(this.limit.sensor.kind);
        }
    },
    methods: {
        getNewLimit() {
            let sensor;
            if (this.sensors.length > 0) {
                sensor = { ...this.sensors[0] };
            } else {
                sensor = {
                    id: -1,
                    name: "",
                    kind: ESensor.WATER_LEVEL_MONITOR
                };
            }
            return {
                sensor,
                condition: this.LimitConditions.GREATER_THAN,
                value: 0.0,
                kind: parseInt(
                    Object.keys(this.readingKinds[sensor.kind])[0],
                    10
                ),
                alert_level: this.AlertLevels.WARNING
            };
        },
        setSensor(sensorId) {
            const sensor = this.sensors.find(sensor => sensor.id === sensorId);
            const kinds = this.readingKinds[sensor.kind];

            this.setProp("sensor", {
                ...sensor
            });

            if (!hasProperty(kinds, this.limit.kind)) {
                this.setProp("kind", Object.keys(kinds)[0]);
            }
        },
        setProp(prop, value) {
            if (
                (prop === "kind" ||
                    prop === "condition" ||
                    prop === "alert_level") &&
                typeof value === "string"
            ) {
                value = parseInt(value, 10);
            }
            this.limit[prop] = value;
        },
        async confirm() {
            this.saving = true;
            await this.$nextTick();
            await sleep(1000);
            const { sensor, ...data } = this.limit;
            const response = await settingsApi.sensors.createLimit(
                this.source,
                {
                    sensor_id: sensor.id,
                    ...data
                }
            );
            this.$bvToast.toast(`Limite criado com sucesso.`, {
                title: "Aviso",
                variant: "success",
                noCloseButton: true
            });
            this.$emit("create-limit", response.data);
            this.$refs.modal.hide();
            this.saving = false;
        },
        show() {
            this.limit = this.getNewLimit();
            this.$refs.modal.show();
        }
    }
};
</script>
